import faker from "./faker";
import helper from "./helper";
import lodash from "./lodash";
import colors from "./colors";
import permissionHelper from "./permissionHelper";

export default (app) => {
  app.use(faker);
  app.use(helper);
  app.use(lodash);
  app.use(colors);
  app.use(permissionHelper);
};
